"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _statusType = require("../../constants/statusType");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColor = function getColor(_ref) {
  var theme = _ref.theme,
      status = _ref.status;

  switch (status) {
    case _statusType.AVAILABLE:
      return (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        border-color: ", ";\n        background-color: ", ";\n      "])), theme.borderColorAvailable, theme.backgroundColorAvailable);

    case _statusType.AWAY:
      return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        border-color: ", ";\n        background-color: ", ";\n      "])), theme.borderColorAway, theme.backgroundColorAway);

    case _statusType.BUSY:
      return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        border-color: ", ";\n        background-color: ", ";\n      "])), theme.borderColorBusy, theme.backgroundColorBusy);

    case _statusType.DO_NOT_DISTURB:
      return (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        border-color: ", ";\n        background-color: ", ";\n      "])), theme.borderColorDoNotDisturb, theme.backgroundColorDoNotDisturb);

    case _statusType.OFFLINE:
      return (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        border-color: ", ";\n        background-color: ", ";\n      "])), theme.borderColorOffline, theme.backgroundColorOffline);

    case _statusType.ON_BREAK:
      return (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        border-color: ", ";\n        background-color: ", ";\n      "])), theme.borderColorOnBreak, theme.backgroundColorOnBreak);

    case _statusType.ON_CALL:
      return (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        border-color: ", ";\n        background-color: ", ";\n      "])), theme.borderColorOnCall, theme.backgroundColorOnCall);

    case _statusType.WORKING_OFFLINE:
      return (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n        border-color: ", ";\n        background-color: ", ";\n      "])), theme.borderColorWorkingOffline, theme.backgroundColorWorkingOffline);

    default:
      return (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        border-color: ", ";\n        background-color: ", ";\n      "])), theme.borderColorAvailable, theme.backgroundColorAvailable);
  }
};

var _default = getColor;
exports["default"] = _default;